import * as THREE from 'three';
import IMOG from '~/lib/imog';
import Geometry from './Geometry';
import loadGLTF from '~/lib/three/loadGLTF';

import { VertexNormalsHelper } from 'three/examples/jsm/helpers/VertexNormalsHelper';

import FloorMeshStandardMaterial from './FloorMeshStandardMaterial';

// const g = new Geometry(20, 20, 128, 128);
// const g = new Geometry(20, 20, 5, 5);

export default IMOG.Component('Floor', {
  options: {
    addTo: null,
  },

  props() {
    return {};
  },

  async setup({ options }) {
    const { scene } = await loadGLTF('/gltf/env.glb', {
      renderer: this.$renderer,
    });

    const color = new THREE.Color(0x292b33);
    color.offsetHSL(0, 0, 0.05);
    this.floorMaterial = new FloorMeshStandardMaterial({
      color: color,
      roughness: 0.6,
      // metalness: 0.5,
      // side: THREE.DoubleSide,
      // wireframe: true,
    });
    const color2 = new THREE.Color(0x292b33);
    color2.offsetHSL(0, -0.03, -0.08);
    this.defaultMaterial = new THREE.MeshStandardMaterial({
      color: color2,
      // roughness: 0.5,
      metalness: 0.5,
      // wireframe: true,
    });
    const color3 = new THREE.Color(0x292b33);
    color3.offsetHSL(0, 0, -0.12);
    this.darkMaterial = new THREE.MeshStandardMaterial({
      color: color3,
      // roughness: 0.9,
      // metalness: 0.5,
      // wireframe: true,
    });

    // this.mesh = new THREE.Mesh(g, this.material);
    scene.traverse((obj) => {
      if (obj.isMesh) {
        obj.receiveShadow = true;

        if (obj.name !== 'Floor_Sides') {
          obj.geometry.computeBoundsTree();
          this.$solids.push(obj);
        }

        if (obj.name === 'Floor') obj.material = this.floorMaterial;
        else if (obj.name === 'Floor_Sides') obj.material = this.darkMaterial;
        else obj.material = this.defaultMaterial;

        // this.mesh.name = 'Floor';
      }
    });
    if (options.addTo) options.addTo.add(scene);
    scene.position.z = -10;
    scene.position.x = -2;
    scene.position.y = -2;

    // this.mesh.position.x = 12;

    // this.helper = new VertexNormalsHelper(this.mesh, 0.5, 0x00ff00);
    // this.mesh.add(this.helper);

    if (this._loadedResolve) this._loadedResolve();
    this._loaded = true;
  },

  methods: {
    loaded() {
      return new Promise((resolve) => {
        if (this._loaded) {
          resolve();
          return;
        }
        this._loadedResolve = resolve;
      });
    },
  },
});
